import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/intercom.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/intercom.jpg";
import type { Product } from "../../types";
import { readersAndIntercom } from "../product-list-groups/readersAndIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const intercom: Product = {
  id: "intercom",
  productTitle: "Intercom",
  description: "intercom.description.1",
  descriptionMaxWidth: 120,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-intercom`,
  ],
  productListGroup: readersAndIntercom,
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessIntercoms,
    productSlug: "ua-intercom",
  },
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 255,
    height: 182,
  },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '324.8 x 113.7 x 28.3 mm\n(12.8 x 4.5 x 1.1")',
      },
    },
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '324.8 x 113.7 x 28.3 mm\n(12.8 x 4.5 x 1.1")',
      },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: "appleTouchPassAccess",
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: "builtInFloodlight",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "intercoms.common.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
};
